import React, { useState } from "react";
import styles from "./style.module.scss";
import { Button } from "@learningblocks/shared-components";
import check from "./img/check.svg";
import { SimManager } from "@learningblocks/simulation-engine";

export function DialysisConcentrationToggle(props) {
  const [selectedOption, setSelectedOption] = useState(props.concentration);

  return (
    <div className={styles.dialysisConcentrationToggle}>
      <h4 className={styles.heading}>{props.heading}</h4>
      <p className={styles.description}>{props.description}</p>
      <div className={styles.optionsGroup}>
        {props.options.map((option) => (
          <button
            className={
              option.value === selectedOption
                ? styles.selected
                : styles.unselected
            }
            onClick={() => {
              setSelectedOption(option.value);
            }}
          >
            <div className={styles.checkbox}>
              {option.value === selectedOption ? (
                <img src={check} alt="Check" />
              ) : null}
            </div>
            <div className={styles.optionText}> {option.text} </div>
          </button>
        ))}
      </div>
      <div className={styles.footer}>
        <Button
          className={styles.submitButton}
          disabled={props.concentrationSelected ? true : false}
          onClick={() => {
            SimManager.getInstance().setInputValue("Poster", {
              concentration: selectedOption,
            });
            props.setConcentration(selectedOption);
          }}
        >
          Confirm selection
        </Button>
      </div>
    </div>
  );
}

DialysisConcentrationToggle.propTypes = {};
